import { render } from "./CreatePptModal.vue?vue&type=template&id=bcb99642"
import script from "./CreatePptModal.vue?vue&type=script&lang=js"
export * from "./CreatePptModal.vue?vue&type=script&lang=js"
script.render = render

export default script